export default __webpack_public_path__ + "static/char-s-43-en-44a68e2ed15e3c98b7815698e293e82b.webp";